import { render, staticRenderFns } from "./closedSpaceEquipDetail.vue?vue&type=template&id=4ca23136"
import script from "./closedSpaceEquipDetail.vue?vue&type=script&lang=js"
export * from "./closedSpaceEquipDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca23136')) {
      api.createRecord('4ca23136', component.options)
    } else {
      api.reload('4ca23136', component.options)
    }
    module.hot.accept("./closedSpaceEquipDetail.vue?vue&type=template&id=4ca23136", function () {
      api.rerender('4ca23136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/closedSpaceEquipDetail.vue"
export default component.exports